import React from 'react';
import { Play } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Hero = () => {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate('/login');
  };

  const scrollToParticipate = () => {
    const element = document.getElementById('participar');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative pt-20 pb-24 overflow-hidden bg-grid">
      <div className="container mx-auto px-4 md:px-8 relative z-10">
        <div className="flex flex-col items-center text-center max-w-4xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-purple-100 text-purple-700 px-4 py-1.5 rounded-full text-sm font-bold mb-8 animate-fade-in">
            <span className="flex h-2 w-2 rounded-full bg-purple-600"></span>
            Lançamento: O Sôra é gratuito hoje
          </div>

          <h1 className="font-hero text-5xl md:text-7xl mb-8 leading-[1] text-black">
            Menos tempo preparando aula, <span className="text-purple-600">mais tempo ensinando</span>
          </h1>

          <p className="text-lg md:text-xl text-gray-600 mb-10 max-w-2xl leading-relaxed font-medium">
            O repositório colaborativo feito por professores do ensino fundamental.
            Materiais para impressão, planos de aula organizados e troca real entre educadores.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto">
            <button
              onClick={handleLoginClick}
              className="w-full sm:w-auto bg-purple-600 hover:bg-purple-700 text-white font-display py-4 px-10 rounded-full text-lg shadow-xl shadow-purple-200 transition-all active:scale-95"
            >
              Entrar na plataforma
            </button>
            {/* <button 
              onClick={scrollToParticipate}
              className="w-full sm:w-auto bg-white border-2 border-gray-200 hover:border-purple-200 text-gray-700 font-display py-4 px-10 rounded-full text-lg transition-all active:scale-95"
            >
              Participar da comunidade
            </button> */}
          </div>

          <div className="mt-12 flex flex-col items-center gap-4">
            {/* <button className="flex items-center gap-2 text-purple-600 font-bold group">
                <div className="w-12 h-12 rounded-full bg-purple-600 flex items-center justify-center text-white group-hover:scale-110 transition-transform shadow-lg">
                  <Play size={20} fill="currentColor" />
                </div>
                <span>Assistir introdução</span>
             </button> */}
          </div>
        </div>

        {/* <div className="mt-20 relative max-w-6xl mx-auto">
          <div className="bg-[#6B21A8] rounded-[3rem] p-4 md:p-8 shadow-2xl relative overflow-hidden">
            <img 
              src="https://images.unsplash.com/photo-1544717305-27a734ef1904?q=80&w=2070&auto=format&fit=crop" 
              alt="Professora organizando materiais de aula em uma sala ensolarada"
              className="w-full h-auto rounded-[2rem] object-cover max-h-[600px] animate-fade-in shadow-inner"
            />
            
            <div className="absolute top-12 left-12 hidden lg:block bg-white p-4 rounded-2xl shadow-xl animate-bounce-slow">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-yellow-400 rounded-full flex items-center justify-center text-black font-bold text-xl">📁</div>
                <div>
                  <div className="text-xs text-gray-500 uppercase font-bold">Arquivos</div>
                  <div className="text-sm font-bold">Aulas de Ciências</div>
                </div>
              </div>
            </div>
            <div className="absolute bottom-12 right-12 hidden lg:block bg-white p-4 rounded-2xl shadow-xl animate-bounce-slow" style={{ animationDelay: '1s' }}>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center text-purple-600 font-bold text-xl">🤝</div>
                <div>
                  <div className="text-xs text-gray-500 uppercase font-bold">Comunidade</div>
                  <div className="text-sm font-bold">+120 Novos Planos</div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default Hero;

